var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowRight = function SvgIconArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0328 3.5415L11.1573 4.41541L14.622 7.88005L-1.89644e-07 7.88005L-2.43828e-07 9.11963L14.622 9.11963L11.1511 12.5781L12.0328 13.4582L17 8.49984L12.0328 3.5415Z",
    fill: "#F0F1FA"
  })));
};
export default SvgIconArrowRight;